export const actionTypes = {
    setLastPath: "setLastPath",
    setIsAuthorized: "setIsAuthorized",
};

const initialRoutesState = {
    lastPath: "",
    isAuthorized: false,
};

export const routesReducer = (state = initialRoutesState, action) => {
    switch (action.type) {
        case actionTypes.setLastPath: {
            const {lastPath} = action.payload;
            return {...state, lastPath};
        }
        case actionTypes.setIsAuthorized: {
            const {isAuthorized} = action.payload;
            return {...state, isAuthorized};
        }

        default:
            return state;
    }
};

export const routesActions = {
    setLastPath: lastPath => dispatch =>
        dispatch({
            type: actionTypes.setLastPath,
            payload: {lastPath},
        }),
    setIsAuthorized: isAuthorized => dispatch =>
        dispatch({
            type: actionTypes.setIsAuthorized,
            payload: {isAuthorized},
        }),
};
